export const actions = {
  'channel.create': '创建渠道',
  'channel.update': '修改渠道',
  'channel.delete': '删除渠道',
  'channel.delete_disabled': '清理停用渠道',
  'redemption.create': '生成兑换码',
  'redemption.update': '修改兑换码',
  'redemption.delete': '删除兑换码',
  'wallet.credit': '人工充值',
  'price.create': '发布模型价格',
  'price.delete': '停用模型价格',
  'request.resolve': '人工核算',
};
export const label = (row) =>
  row.title ||
  (row.kind === 'request'
    ? row.model || '模型请求'
    : actions[row.name] || row.name);
export const parseJSON = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
export const pretty = (value) =>
  typeof value === 'string' ? value : JSON.stringify(value, null, 2);
export const money = (value) => `${(Number(value || 0) / 1e6).toFixed(6)} 元`;
export const states = {
  settled: '已结算',
  pending: '待核算',
  reserved: '处理中',
  released: '已释放',
};

export function projectEvents(kind, data) {
  if (!data) return [];
  if (kind === 'operation') {
    return [
      {
        id: 'input',
        title: '操作发起',
        at: 0,
        note: '已认证的操作人提交请求',
        fields: {
          actor_id: data.actor_id,
          subject_user_id: data.subject_user_id,
          method: data.method,
          path: data.path,
          action: actions[data.action] || data.action,
          object_type:
            {
              channel: '渠道',
              redemption: '兑换码',
              price: '模型价格',
              wallet: '钱包',
              request: '调用核算',
            }[data.object_type] || data.object_type,
          object_id: data.object_id,
        },
        content: parseJSON(data.input),
      },
      {
        id: 'before',
        title: '操作前快照',
        at: null,
        note: '变更前读取的对象状态，未记录独立时间戳',
        content: parseJSON(data.before),
      },
      {
        id: 'result',
        title: data.success ? '操作完成' : '操作失败',
        at: data.duration_ms,
        note: data.error || '处理完成',
        failed: !data.success,
        fields: {
          http_status: data.status,
          success: data.success,
          duration_ms: data.duration_ms,
        },
      },
      {
        id: 'after',
        title: '操作后快照',
        at: null,
        note: '对象当前状态；并发操作可能影响快照，账务以钱包流水为准',
        content: parseJSON(data.after),
      },
    ];
  }
  const d = data.diagnostic;
  if (!d) return [];
  const result = [
    {
      id: 'receive',
      title: '请求接收',
      at: 0,
      note: `${d.request_bytes} 字节 · ${d.messages} 条消息 · ${d.tools} 个工具`,
      fields: {
        method: d.method,
        path: d.path,
        user_id: d.user_id,
        token_id: d.token_id,
        model: d.model,
        stream: d.stream,
        request_bytes: d.request_bytes,
        messages: d.messages,
        tools: d.tools,
      },
    },
    {
      id: 'prepare',
      title: '平台处理',
      at: d.upstream_attempts ? d.pre_upstream_ms : d.total_ms,
      duration: d.upstream_attempts ? d.pre_upstream_ms : d.total_ms,
      note: '包含解析、认证、路由、输入估算及钱包预占，未单独采集各子阶段',
      fields: {
        estimated_input_tokens: d.estimated_input_tokens,
        requested_max_tokens: d.requested_max_tokens,
        effective_max_tokens: d.effective_max_tokens,
        channel_id: d.channel_id,
      },
    },
  ];
  if (d.upstream_attempts) {
    result.push({
      id: 'upstream',
      title: '上游响应',
      at: Math.min(d.total_ms, d.pre_upstream_ms + d.upstream_headers_ms),
      start: d.pre_upstream_ms,
      duration: d.upstream_headers_ms,
      note: '包含网络连接、供应商排队及等待响应头',
      failed: d.upstream_status >= 400,
      fields: {
        upstream_url: d.upstream_url,
        actual_model: d.actual_model,
        upstream_status: d.upstream_status,
        upstream_attempts: d.upstream_attempts,
        upstream_headers_ms: d.upstream_headers_ms,
      },
    });
  }
  if (d.stream && d.first_content_ms)
    result.push({
      id: 'first',
      title: '首客户端内容',
      at: d.first_content_ms,
      note: '可能为流式元事件，不等同于首个文本 Token',
      fields: { first_content_ms: d.first_content_ms },
    });
  result.push({
    id: 'finish',
    title: d.error || d.status >= 400 ? '响应异常' : '响应完成',
    at: d.total_ms,
    note: d.error || `HTTP ${d.status}`,
    failed: Boolean(d.error) || d.status >= 400,
    fields: { http_status: d.status, total_ms: d.total_ms, error: d.error },
  });
  if (data.wallet) {
    const w = data.wallet;
    result.push({
      id: 'wallet',
      title: '钱包结算',
      at: null,
      note: '当前结算快照，未记录此阶段的独立耗时',
      fields: {
        state: states[w.state] || w.state,
        reserved: money(w.reserved),
        charged: money(w.charged),
        cost: money(w.cost),
        prompt_tokens: w.prompt_tokens,
        completion_tokens: w.completion_tokens,
        reasoning_tokens: w.reasoning_tokens,
        note: w.note,
      },
    });
  }
  result.push({
    id: 'body',
    title: '请求与响应内容',
    at: null,
    note: d.bodies_enabled
      ? '脱敏记录；流式响应正文不保存'
      : '正文记录默认关闭',
    content: d.bodies_enabled
      ? {
          request: parseJSON(d.request_body),
          response: parseJSON(d.response_body),
        }
      : null,
  });
  return result;
}

export function changes(before, after) {
  const a = parseJSON(before),
    b = parseJSON(after);
  if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return [];
  return [...new Set([...Object.keys(a), ...Object.keys(b)])]
    .filter((key) => JSON.stringify(a[key]) !== JSON.stringify(b[key]))
    .map((key) => ({ key, before: a[key], after: b[key] }));
}

export const fieldNames = {
  actor_id: '操作人',
  subject_user_id: '关联用户',
  method: '请求方法',
  path: '接口',
  action: '操作',
  object_type: '对象类型',
  object_id: '对象编号',
  user_id: '用户',
  token_id: '令牌',
  model: '请求模型',
  stream: '流式',
  request_bytes: '请求字节数',
  messages: '消息数量',
  tools: '工具数量',
  estimated_input_tokens: '估算输入 Token',
  requested_max_tokens: '请求输出上限',
  effective_max_tokens: '实际输出上限',
  channel_id: '渠道',
  upstream_url: '上游地址',
  actual_model: '实际模型',
  upstream_status: '上游状态码',
  upstream_attempts: '上游尝试次数',
  upstream_headers_ms: '上游响应头耗时（ms）',
  first_content_ms: '首内容耗时（ms）',
  status: '状态',
  http_status: 'HTTP 状态码',
  success: '成功',
  duration_ms: '耗时（ms）',
  total_ms: '总耗时（ms）',
  error: '错误',
  state: '钱包状态',
  reserved: '预占',
  charged: '扣费',
  cost: '供应商成本',
  prompt_tokens: '实际输入 Token',
  completion_tokens: '实际输出 Token',
  reasoning_tokens: '其中思考 Token',
  note: '备注',
  quota: '余额／面额（微元）',
  used_quota: '累计使用（微元）',
  id: '编号',
  name: '名称',
  type: '渠道类型',
  base_url: '上游地址',
  models: '模型列表',
  model_mapping: '模型映射',
  priority: '优先级',
  enabled: '启用',
  provider: '供应商',
  kind: '模型类型',
  input_rate: '输入单价（微元／百万 Token）',
  output_rate: '输出单价（微元／百万 Token）',
  cost_input_rate: '输入成本',
  cost_output_rate: '输出成本',
  max_input_tokens: '输入上限',
  max_output_tokens: '输出上限',
  expires_at: '到期时间',
  amount: '金额（微元）',
  reason: '原因',
  business_id: '业务编号',
  credential_changed: '凭据已更新',
  configuration_changed: '配置已更新',
  count: '数量',
  created_ids: '创建对象编号',
  objects: '对象快照',
  limit: '展示上限',
  request: '请求正文',
  response: '响应正文',
  release: '释放预占',
  request_id: '请求 ID',
  input: '操作参数',
  before: '操作前',
  after: '操作后',
};
